"use client";

import { c as _c } from "react/compiler-runtime";
import DropListItemContentMediaImage from "@/components/drops/view/item/content/media/DropListItemContentMediaImage";
import type { ReactNode } from "react";
export type DropPartMarkdownImageLayout = "standalone" | "grouped";
interface DropPartMarkdownImageProps {
  readonly src: string;
  readonly layout?: DropPartMarkdownImageLayout | undefined;
  readonly galleryItemId?: string | undefined;
}
export default function DropPartMarkdownImage(t0) {
  const $ = _c(6);
  const {
    src,
    layout: t1,
    galleryItemId
  } = t0;
  const layout = t1 === undefined ? "standalone" : t1;
  const wrapperClassName = layout === "grouped" ? "tw-relative tw-min-w-0 tw-w-full" : "tw-relative tw-mt-2 tw-w-full";
  let t2;
  if ($[0] !== galleryItemId || $[1] !== src) {
    t2 = <DropListItemContentMediaImage src={src} loadStrategy="eager" intrinsicHeight={true} galleryItemId={galleryItemId} />;
    $[0] = galleryItemId;
    $[1] = src;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2 || $[4] !== wrapperClassName) {
    t3 = <div className={wrapperClassName}>{t2}</div>;
    $[3] = t2;
    $[4] = wrapperClassName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export function DropPartMarkdownImageGroup(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="tw-mt-2 tw-grid tw-w-full tw-grid-cols-1 tw-items-start tw-justify-start tw-gap-2 sm:tw-grid-cols-[repeat(auto-fit,minmax(min(12rem,100%),16rem))]">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}